/**
 * Created by ShaunBetts on 14-May-16.
 */

import PortalError from 'module/error/PortalError';

const ServerError = function (message, code) {
  this.data = new PortalError(message, code).data;
  this.data.type = 'ServerError';
  this.data.typeLabel = 'System Error';
};

ServerError.prototype = Object.create(PortalError.prototype);

export default ServerError;